module.exports = __webpack_public_path__ + "static/media/MMProLogo.55877753.svg";